import React, { useState } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Container from "./Container.jsx";
import axios from "axios";
import Entity from "../datasource/Entity";
import clientConfig from "../config/client";
import { Box } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Ban from "../components/Views/Ban.jsx";

class BanArrivalsContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("banArrivals");
        this.getAuxData();
    }

    render = () => {

        if (this.state.error && this.state.error.status == 403) {
            return <Route render={() => <Redirect to="/hotels" replace />} />;
        }

        const rates =
            this.props.auxData &&
            this.props.auxData.rates?.filter((r) => r.active);
        const roomTypes =
            this.props.auxData &&
            this.props.auxData.room_types?.filter((r) => r.active);

        let banArr = (
            <Box mt={4}>
                <LinearProgress mt={3} />
            </Box>
        );

        if (rates && roomTypes) {
            banArr = (
                <Ban
                    rates={rates}
                    roomTypes={roomTypes}
                    hotelId={this.datasource.baseId}
                    banArrivals={this.state.AllItems}
                    initAction={this.getAllItems}
                />
            );
        }

        return (
            <Paper elevation={3}>
                <Box p={3}>
                    <Typography mb={3} variant={"h5"}>
                        Закрытие заездов\выездов
                    </Typography>
                </Box>
                {banArr}
            </Paper>
        );
    };
}

export default BanArrivalsContainer;
